
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100%","height":"100%","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.63606 6.63604C6.24553 7.02656 6.24553 7.65973 6.63606 8.05025L11.5858 13L6.63606 17.9497C6.24553 18.3403 6.24553 18.9734 6.63606 19.364C7.02658 19.7545 7.65975 19.7545 8.05027 19.364L13 14.4142L17.9498 19.364C18.3403 19.7545 18.9735 19.7545 19.364 19.364C19.7545 18.9734 19.7545 18.3403 19.364 17.9497L14.4142 13L19.364 8.05025C19.7545 7.65973 19.7545 7.02656 19.364 6.63604C18.9735 6.24551 18.3403 6.24552 17.9498 6.63604L13 11.5858L8.05027 6.63604C7.65974 6.24551 7.02658 6.24551 6.63606 6.63604Z","fill":"currentColor"}})])
          )
        }
      }
    